<template>
    <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="blue darken-3"
    dark
    flat
    >
        <v-img
            class="top-logo"
            max-width="150"
            src="https://api.mrpoolal.com/assets/theme/img/mrpool/logo.png"
            alt="Mr. Pool"
        ></v-img>
        <v-spacer></v-spacer>
        <v-btn icon  @click.stop="profileToggle = !profileToggle">
            <v-icon>mdi-account</v-icon>
        </v-btn>
        <v-btn icon @click.prevent="signOut">
            <v-icon>mdi-logout</v-icon>
        </v-btn>
    </v-app-bar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data: () => ({
        back: false
    }),
    computed: {
        ...mapGetters({
            profile: 'menu/profileDialog'
        }),
        menuToggle: {
            get() {
                return this.$store.state.menu.show_menu
            },
            set(newValue) {
                this.$store.commit('SET_MENU', newValue)
            }
        },
        profileToggle: {
            get() {
                return this.profile
            },
            set(newValue) {
                this.$store.commit('menu/SET_PROFILE_DIALOG', newValue)
            }
        },
    },
    methods: {
        ...mapActions({
            signOutAction: 'auth/signOut'
        }),
        signOut() {
            this.signOutAction().then(() => {
                this.$router.replace({
                    name: 'Home'
                })
            })
        },
        hasHistory () { 
            return window.history.length > 2 
        },
    },
    mounted() {
        if(this.$route.name != 'Dashboard') {
            this.back = true
        }
    },
    watch:{
        $route (to){
            if(to.name == 'Dashboard') {
                this.back = false
            } else {
                this.back = true
            }
        }
    } 
}
</script>